import { render, staticRenderFns } from "./MyArticleRunning.vue?vue&type=template&id=f63fceaa&scoped=true&"
import script from "./MyArticleRunning.vue?vue&type=script&lang=js&"
export * from "./MyArticleRunning.vue?vue&type=script&lang=js&"
import style0 from "./MyArticleRunning.vue?vue&type=style&index=0&id=f63fceaa&lang=scss&scoped=true&"
import style1 from "./MyArticleRunning.vue?vue&type=style&index=1&id=f63fceaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63fceaa",
  null
  
)

export default component.exports